module.exports = __webpack_public_path__ + "static/media/garage-car.f167ca41.svg";